import _ from "lodash";
import * as Tag from "@/helper/characteristic/Tag";
import {isEmptyArray} from "@/helper/Array";
import {getParents} from "@/helper/application/characteristic/Provider";

export function isMandatory (functions)
{
	if (!functions)
	{
		return false;
	}

	return _
		.filter(
			functions,
			characteristic => Tag.hasTag(characteristic, Tag.FUNCTION_INDUSTRIAL_SECTOR_MANDATORY)
		)
		.length > 0;
}

export function isSuppress (meta, functions)
{
	if (!functions || isEmptyArray(functions))
	{
		return false;
	}

	let suppressCount = 0;

	functions.forEach(theFunction =>
	{
		const characteristicsToCheck = getParents(theFunction.item.id, meta.function);
		characteristicsToCheck.push(theFunction.item);

		const characteristicsWithRelevantTag = characteristicsToCheck.filter(
			characteristic => Tag.hasTag(characteristic, Tag.FUNCTION_INDUSTRIAL_SECTOR_SUPPRESS)
		);

		if (characteristicsWithRelevantTag.length > 0)
		{
			suppressCount++;
		}
	});

	return suppressCount === functions.length;
}
